import React from 'react';
import { List, ListItem, ListItemText, Stack } from '@mui/material';

export default ({ value }: { value: string | string[] }) => {
    return Array.isArray(value) ? (
        <List dense>
            {value.map((val, index) => (
                <ListItem key={`${val}_${index}`}>
                    <ListItemText primary={val} />
                </ListItem>
            ))}
        </List>
    ) : (
        <Stack sx={{ overflow: 'hidden', wordWrap: 'break-word' }}>{value}</Stack>
    );
};
